import EditarPerfil from '../../SVG/Editarperfil.svg'
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import "../css/configUser.css";
import { actualizarContrasenia, obtenerUsuarioActual } from "../../redux/usuariosSlice";
import OperationStatus from '../../config/OperationStatus'
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { getConfiguration } from "../../Api/content";
import { useLocale } from "../../i18n/localeContext";
import { Skeleton } from "antd";
import { StrapiError } from '../../Inicio/Pages/StrapiError';


import { useValidation } from "../../Hooks/useValidation";
export default function ConfigUser() {
  const { validation } = useValidation();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { register, handleSubmit, watch, formState: { errors } } = useForm();
  const nuevaContrasena = watch("nuevaContrasena");
  const [configuration, setConfiguration] = useState(null);
  const [isLoadingContent, setIsLoadingContent] = useState(true);
  const { locale } = useLocale();
  const [hasError, setHasError] = useState(false);
  const onSubmit = async (data) => {
    let { payload } = await dispatch(actualizarContrasenia(data));
    if (payload.operationStatus === OperationStatus.SUCCESS) {
      toast.success(payload.message);
      dispatch(obtenerUsuarioActual());
      navigate("/");
    } else {
      toast.error(payload.message);
    }
  }

  const passwordVerify = (e) => {
    return nuevaContrasena === e
  }

  useEffect(() => {
    let cancel = false;
    setHasError(false);
    setIsLoadingContent(true);
    const timeoutId = setTimeout(() => {
      if (!cancel) {
        setConfiguration(null);
        setIsLoadingContent(false);
        setHasError(locale === 'en');
      }
    }, 5000);
      getConfiguration(locale)
      .then((res) => {
        clearTimeout(timeoutId);
        const data = res?.data?.attributes || res?.data || res;
        if (!cancel) {
          setConfiguration(data);
          setIsLoadingContent(false);
        }
      })
      .catch((error) => { 
        clearTimeout(timeoutId);
        if (!cancel) {
          setConfiguration(null);
          setIsLoadingContent(false);
          setHasError(locale === 'en');
        }
      });
    return () => { cancel = true; 
      clearTimeout(timeoutId); };
  }, [locale]);

  if (isLoadingContent) {
    return (
      <div className="rootConfig">
        <div className='principal'>
          <div className="container-root">
            <Skeleton.Input style={{ width: 250, height: 30 }} active />
            <div className="form-config">
              <div className="grid-container container col-2">
                <div className="grid-container col-2 col-lg-2 col-sm-12">
                  <div className="grid-item">
                    <div className="form-group">
                      <Skeleton.Input style={{ width: 150, height: 20 }} active />
                      <Skeleton.Input style={{ width: '100%', height: 40 }} active />
                    </div>
                  </div>
                  <div className="grid-item">
                    <div className="form-group">
                      <Skeleton.Input style={{ width: 120, height: 20 }} active />
                      <Skeleton.Input style={{ width: '100%', height: 40 }} active />
                    </div>
                  </div>
                  <div className="grid-item">
                    <div className="form-group">
                      <Skeleton.Input style={{ width: 180, height: 20 }} active />
                      <Skeleton.Input style={{ width: '100%', height: 40 }} active />
                    </div>
                  </div>
                </div>
                <div className="button-control">
                  <Skeleton.Image style={{ width: 200, height: 150 }} active />
                  <div>
                    <Skeleton.Button style={{ width: 100, height: 40 }} active />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (hasError && locale === 'en') {
    return <StrapiError 
      onRetry={() => {
        setHasError(false);
        setIsLoadingContent(true);
      }}
      onUseDefault={() => {
        setHasError(false);
        setIsLoadingContent(false);
        setConfiguration(null);
      }}
    />
  }

  return (
    <div className="rootConfig">
      <div className='principal'>
        <div className="container-root">
          <h2>{configuration?.subtitle || 'Cambio de contraseña'}</h2>
          <form onSubmit={handleSubmit(onSubmit)} className="form-config">
            <div className="grid-container container col-2">
              <div className="grid-container col-2 col-lg-2 col-sm-12">
                <div className="grid-item">
                  <div className="form-group">
                    <label>{configuration?.last_password || 'Contraseña anterior'}</label>
                    <input className="form-control" autoComplete="current-password" type="password"
                      {...register("antiguaContrasena", { required: validation?.required_field || "Campo requerido" })}
                    />
                    {errors.antiguaContrasena && <p className="error">{errors.antiguaContrasena.message}</p>}

                  </div>
                </div>

                <div className="grid-item">
                  <div className="form-group">
                    <label>{configuration?.new_password || 'Nueva Contraseña'}</label>
                    <input className="form-control" autoComplete="new-password" type="password"
                      {...register("nuevaContrasena", { required: validation?.required_field || "Campo requerido" })}
                    />
                    {errors.nuevaContrasena && <p className="error">{errors.nuevaContrasena.message}</p>}
                  </div>
                </div>

                <div className="grid-item">
                  <div className="form-group">
                    <label>{configuration?.confirm_password || 'Confirmar contraseña'}</label>
                    <input className="form-control" autoComplete="new-password" type="password"
                      {...register("confirmarContrasenia", { required: validation?.required_field || "Campo requerido", validate: passwordVerify })}
                    />
                    {errors.confirmarContrasenia && <p className="error">{errors.confirmarContrasenia.message}</p>}
                    {errors?.confirmarContrasenia?.type === "validate" && <p className="error">Las contraseñas no coinciden</p>}

                  </div>
                </div>
              </div>

              <div className="button-control">
                <img src={EditarPerfil} alt="Imagen editar perfil" />
                <div>
                  <button type="submit">{configuration?.save_button || 'Guardar'}</button>
                </div>
              </div>
            </div>

          </form>
        </div>
      </div>
    </div>
  )
}